import { Injectable } from '@angular/core';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { flattenDeep } from 'lodash-es';

import { roleIsGreaterEqThan } from 'auth/account-role-helper';
import { getSafe } from 'helpers';

import { UserDetailsFragment, UserRole } from 'generated/graphql';
import { Store } from '@ngrx/store';
import { selectCurrentUser } from 'app/_state/auth/auth-selectors';
import { filter, firstValueFrom, lastValueFrom, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccountRoleService {

  get userRole() {
    return getSafe(() => this._tokenService.currentUserData['role'], '').toLowerCase();
  }

  constructor(
    private _tokenService: AngularTokenService,
    private _store: Store<any>,
  ) {
  }


  async getCurrentUserAsync(): Promise<UserDetailsFragment> {
    const user = await lastValueFrom(
      this._store.select(selectCurrentUser).pipe(take(1))
    );
    return user;
  }

  /**
   * Returns true if user has the required role
   * returns false if the user does not have the required role.
   */
  userHasRole(...roles: UserRole[]) {
    if (!roles) {
      return false;
    }
    const fixedRoles: UserRole[] = flattenDeep(roles);
    return fixedRoles.map(r => r.toLowerCase()).includes(this.userRole);
  }

  userHasMinRole(role: UserRole) {
    if (!role) {
      return false;
    }
    return roleIsGreaterEqThan(this.userRole, role);
  }
}
